import { withInstall } from "../utils/index.mjs";
import _Switch from "./Switch.mjs";
const Switch = withInstall(_Switch);
var stdin_default = Switch;
export {
  Switch,
  stdin_default as default
};
